/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Windows_2Inputs */

const en_pc_dl_windows_2 = /** @type {(inputs: Pc_Dl_Windows_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click the .msi. It installs for all users, so Windows asks for administrator permission. The installer is code-signed.`)
};

const zh_pc_dl_windows_2 = /** @type {(inputs: Pc_Dl_Windows_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双击 .msi 安装。它为所有用户安装，因此 Windows 会请求管理员权限。安装包已经过代码签名。`)
};

/**
* | output |
* | --- |
* | "Double-click the .msi. It installs for all users, so Windows asks for administrator permission. The installer is code-signed." |
*
* @param {Pc_Dl_Windows_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_windows_2 = /** @type {((inputs?: Pc_Dl_Windows_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Windows_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_windows_2(inputs)
	return zh_pc_dl_windows_2(inputs)
});
export { pc_dl_windows_2 as "pc.dl.windows.2" }